import { render, staticRenderFns } from "./detailedStatistics.vue?vue&type=template&id=03db8b41&scoped=true"
import script from "./detailedStatistics.vue?vue&type=script&lang=js"
export * from "./detailedStatistics.vue?vue&type=script&lang=js"
import style0 from "./detailedStatistics.vue?vue&type=style&index=0&id=03db8b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db8b41",
  null
  
)

export default component.exports